if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    console.log('response1', response);
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              loadCartRecommendations(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}



function loadCartRecommendations(response) {
  console.log('response', response);

  const addedItem = response.id; // the product just added
  const productId = response.product_id;
  const productHandle = response.handle;
  const productTitle = response.title;
  const variantTitle = response.variant_title;
  const cartProductTitle = response.product_title.toLowerCase();

  console.log("Added Product:", productTitle, productId, productHandle);

  fetch(`/collections/all/products.json?limit=250`)
    .then(res => res.json())
    .then(data => {
      console.log("data----->", data);

      const wrapper = document.querySelector('.cart-drawer-recommendations');
      const wrapperHeading = document.querySelector('.recommendations-heading');
      wrapper.innerHTML = '';
      // normalization function
      function normalizeTitle(title) {
        return title
          .toLowerCase()
          .split("–")[0]
          .replace(/scrub/gi, "")
          .replace(/top/gi, "")
          .replace(/pants?/gi, "")
          .replace(/\d+-?pocket/gi, "")
          .replace(/\s+/g, " ")
          .trim();
      }

      const normalizedCartTitle = normalizeTitle(cartProductTitle);

      // filter products
      const filteredProducts = data.products.filter(p => {
        const normalizedTitle = normalizeTitle(p.title);

        return (
          !p.handle.includes("set") &&
          !p.handle.includes("redo") &&
          p.handle !== productHandle &&
          normalizedTitle === normalizedCartTitle
        );
      });

      // add underscrub if needed
      if (productHandle.toLowerCase().includes("women")) {
        const underscrubProduct = data.products.find(
          p => p.handle.toLowerCase().includes("women") &&
               p.handle.toLowerCase().includes("underscrub")
        );
        if (underscrubProduct && !filteredProducts.includes(underscrubProduct)) {
          filteredProducts.push(underscrubProduct);
        }
      } else if (productHandle.toLowerCase().includes("men")) {
        const underscrubProduct = data.products.find(
          p => p.handle.toLowerCase().includes("men") &&
               p.handle.toLowerCase().includes("underscrub")
        );
        if (underscrubProduct && !filteredProducts.includes(underscrubProduct)) {
          filteredProducts.push(underscrubProduct);
        }
      }

      console.log("filteredProducts----->", filteredProducts);

        filteredProducts.forEach(p => {
          // Find matching variant for color (based on the added product)
        let matchingVariant;

        if (p.handle.toLowerCase().includes("underscrub")) {
          matchingVariant = p.variants[0];
        } else {
          matchingVariant = p.variants.find(
            v => v.title.toLowerCase().includes(variantTitle.toLowerCase())
          );
        }
          console.log("matchingVariant--------------_>", matchingVariant);

          // Detect color option (assuming option1 = Color, option2 = Size)
          const color = matchingVariant ? matchingVariant.option1 : null;

          console.log("color----->", color)
          const sizes = [
            ...new Set(
              p.variants
                .filter(v => v.option1 === color) // only variants with same color
                .map(v => v.option2) // collect sizes
            )
          ];

          // Build size dropdown for this color
          let sizeDropdown = "";
          if (sizes.length > 0) {
            sizeDropdown = `<select id="size-drop" class="size-dropdown" data-product-id="${p.id}" data-color="${color}">`;
            sizes.forEach(size => {
              // Find variant that matches both color + size
              const variantForSize = p.variants.find(
                v => v.option1 === color && v.option2 === size
              );
              if (!variantForSize) return;

              const selected =
                matchingVariant && variantForSize.id === matchingVariant.id
                  ? "selected"
                  : "";
              sizeDropdown += `<option value="${variantForSize.id}" ${selected}>${size}</option>`;
            });
            sizeDropdown += `</select>`;
          }

              // Image fallback logic
              let imageUrl = "";
              if (matchingVariant?.featured_image?.src) {
                imageUrl = matchingVariant.featured_image.src;
              } else if (p.variants[0]?.featured_image?.src) {
                imageUrl = p.variants[0].featured_image.src;
              } else if (p.featured_image?.src) {
                imageUrl = p.featured_image.src;
              } else {
                imageUrl = "https://via.placeholder.com/100x100?text=No+Image";
              }
          wrapperHeading.innerHTML = "Don't Miss These";
          wrapper.innerHTML += `
            <div class="recommended-item-wrapper">
              <div class="recommended-item">
                <img src="${imageUrl}" alt="${p.title}" style="width:50px;" />
                <div class="inner-content">
                  <p>${p.title}</p>
                  <div class="button-select">
                    <div class="size">${sizeDropdown}</div>
                    <button class="add-rec-btn">Add to Cart</button>
                  </div>
                </div>
              </div>
            </div>`;
        });


              const $slider = $('.cart-drawer-recommendations');

              if ($slider.length) {
                // destroy old slick if already initialized
                if ($slider.hasClass('slick-initialized')) {
                  $slider.slick('unslick');
                }

                // re-init slick
                $slider.slick({
                  dots: false,
                  arrows: true,
                  infinite: true,
                  adaptiveHeight: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0602/5150/4872/files/Left.svg?v=1743074509' alt='left_arrow'>",
                  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0602/5150/4872/files/Right_2.svg?v=1743074509' alt='right_arrow'>"
                });
              }

  wrapper.querySelectorAll('.add-rec-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    const parent = e.target.closest('.recommended-item');
    const selectEl = parent.querySelector('.size-dropdown');
    const variantId = selectEl ? selectEl.value : null;

    if (!variantId) {
      alert("Please select a size before adding to cart.");
      return;
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', 1);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((res) => res.json())
      .then((cartResponse) => {
        console.log("Recommended product added:", cartResponse);
        if (cart && cartResponse) {
          cart.renderContents(cartResponse);
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
          }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartResponse }));

        const addedItem = cartResponse.items?.[0]; 
        console.log("Added item:", addedItem);

        if (typeof loadCartRecommendations === 'function' && addedItem) {
          loadCartRecommendations(addedItem);
        }
      })
      .catch(err => console.error("Error adding recommended product:", err));
    });
  });


      })
      .catch(err => console.error('Error fetching recommendations:', err));
}

  document.addEventListener("click", function (e) {
    // REMOVE button
    if (e.target.closest(".cart-remove-button")) {
      updateRecommendationsAfterCartChange();
    }

    // PLUS / MINUS buttons
    if (e.target.closest(".quantity__button")) {
      updateRecommendationsAfterCartChange();
    }

    if (e.target.closest(".header__icon--cart")) {
      updateRecommendationsAfterCartChange();
    }

  });


  // shared function
  function updateRecommendationsAfterCartChange() {
    // Give Shopify a moment to process the cart update
    setTimeout(() => {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          console.log("Cart after change:", cart);

          // use first item in cart as the "base" for recommendations
          const firstItem = cart?.items?.[0];

          if (typeof loadCartRecommendations === "function" && firstItem) {
            loadCartRecommendations(firstItem);
          }
        })
        .catch(err => console.error("Error refreshing cart after change:", err));
    }, 1000);
  }
